import React from 'react';
import { bank_account } from '../utils/DictionaryManagementUtils';
import DefaultPanelManuelRecipient from '../components/PanelsComponents/ManuelRecipient/DefaultPanelManuelRecipient';

//= ========================================================================
const Panel_F06_RequestPaymentToAccountManually = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const manualName = bank_account;

  return (
    <DefaultPanelManuelRecipient
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      onConfigChanged={onConfigChanged}
      onGotoEdit={onGotoEdit}
      onStepPressed={onStepPressed}
      language={language}
      manualName={manualName}
    />
  );
};

export default Panel_F06_RequestPaymentToAccountManually;
